var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 10 11",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v12h-12z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.8285 3.6715c1.562 1.562 1.562 4.095 0 5.657s-4.095 1.562-5.657 0-1.562-4.095 0-5.657 4.095-1.562 5.657 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.25 6.499c0-.138-.112-.2495-.25-.24900168-.138.00050168-.25.11250168-.25.25050168s.1115.24949832.2495.24949832.25-.11199832.2505-.25049832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 4.5v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 1h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 3-1-1 .5.5-1.1715 1.1715"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.03c0061fd32de2465ac08cb063a76663.svg";
export { ForwardRef as ReactComponent };